import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HhsgSharedEllipseSelectOption } from '../../../models/ellipses.model';

/**
 * This is the shared ellipses component.
 */
@Component({
  selector: 'hhsg-shared-ellipses-control',
  templateUrl: './ellipses-control.component.html',
  styleUrls: ['./ellipses-control.component.scss'],
})
export class HhsgSharedEllipsesControlComponent implements OnInit {
  @ViewChild('ellipsesMenu') ellipsesMenu: ElementRef;

  @Input() ellipsesMenuItems: HhsgSharedEllipseSelectOption[] = [];
  @Output() ellipsesButtonClicked = new EventEmitter();

  public useElipsesButton = false;

  constructor() { }

  public ngOnInit(): void {
    this.useElipsesButton = this.ellipsesMenuItems && this.ellipsesMenuItems.length > 0;
  }

  public onEllipsisButtonClicked(event: any) {
    if (event.itemData.text) {
        this.ellipsesButtonClicked.emit(event.itemData.text);
    }
  }

  public changeMenuItemEnabled(menuName: string, isEnabled: boolean) {
    const foundItem = this.ellipsesMenuItems?.find(obj => obj.labelName === menuName);
    if (foundItem) {
      foundItem.isEnabled = isEnabled;
    }
  }
}
